import React from 'react';

import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';
import FormFields from '../FormFields';
import { IsObjectEmpty, IsListEmpty, IsStringEmpty, htmlToText, Log, GetObjectClone } from '../../../utilities/CommonMethods';
import CloseIcon from "../../../assets/icons/icon-close-black.png";
import AddIcon from "../../../assets/icons/icon-add-blue.svg";

import classes from './SessionPlanForm.module.css';
import SubTopicInput from '../../UI/SubTopicInput/SubTopicInput';
import FlexModal from '../../UI/FlexModal/FlexModal';
import { parseTimeForInputField } from '../../../utilities/DateTimeUtils';

class SessionPlanForm extends React.Component {

    state = {
        sessionPlanFormData: GetObjectClone(FormFields.sessionPlanFormData),
        sessionPlanFormValid: false,
        subTopicsList: [
            { id: '', value: '', errorMessage: '', remainingChar: 150, totalChar: 150, valid: true }
        ],
        showError: false,
        errorMessage: ''
    }

    checkRemainingCount = (value, inputIdentifier) => {
        var maxLength = this.state.sessionPlanFormData[inputIdentifier].totalChar;
        var remainingCount = maxLength - value.length;
        return (remainingCount);
    }

    checkValidity = (formElement) => {
        let isValid = true;

        const rules = formElement.validation;
        let value = formElement.value;

        if (!IsObjectEmpty(formElement.validation)) {
            const rules = formElement.validation;
            if (!IsObjectEmpty(rules.required) && rules.required.value) {
                if (typeof (value) === 'string' && value !== ' ' && value !== '' && value.length > 0) {
                    isValid = true && isValid;
                } else if ((typeof (value) === 'number' && parseInt(value, 10)) || value === 0) {
                    isValid = true && isValid;
                } else {
                    isValid = false;
                }
                formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
                formElement.valid = isValid;
            }
        }

        return (formElement);
    }

    inputChangedHandlerMarkdown = (value, inputIdentifier) => {
        // Log('Markdown handler called');
        // value = value === '<p><br></p>' ? '' : value;
        // const plainTextValue = htmlToText(value);

        const updatedForm = this.state.sessionPlanFormData;
        let updatedFormElement = updatedForm[inputIdentifier];
        // if (inputIdentifier === 'sessionDescription') {
        //     updatedFormElement.remainingChar = this.checkRemainingCount(plainTextValue, inputIdentifier)
        //     if (updatedFormElement.remainingChar <= 0) {
        //         updatedFormElement.value = value.substring(0, updatedFormElement.totalChar);
        //         updatedFormElement.remainingChar = 0;
        //     } else {
        //         updatedFormElement.value = value;
        //     }
        // }
        updatedFormElement.value = value;

        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        this.setState({ sessionPlanFormData: updatedForm, sessionPlanFormValid: formIsValid });
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = { ...this.state.sessionPlanFormData };
        let updatedFormElement = { ...updatedForm[inputIdentifier] };

        updatedFormElement.value = event.target.value;
        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedFormElement.valid = updatedFormElement.valid
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;

        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }

            this.setState({ sessionPlanFormData: updatedForm, sessionPlanFormValid: formIsValid });
        }
    }

    onDropDownClick = (inputIdentifier) => {
        const updatedForm = this.state.sessionPlanFormData;
        const updatedFormElement = updatedForm[inputIdentifier];
        const updatedState = updatedFormElement.dropdownOpen ? false : true;

        for (let item in updatedForm) {
            updatedForm[item].dropdownOpen = false;
        }

        updatedFormElement.dropdownOpen = updatedState;
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        this.setState({ sessionPlanFormData: updatedForm, sessionPlanFormValid: formIsValid });
    }

    onDropDownItemClick = (pos, inputIdentifier) => {
        const updatedForm = this.state.sessionPlanFormData;
        let updatedFormElement = updatedForm[inputIdentifier];

        updatedFormElement.value = pos;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedFormElement.dropdownOpen = false;
        updatedForm[inputIdentifier] = updatedFormElement;

        this.setState({ sessionPlanFormData: updatedForm });
    }

    checkRemainingCountForSubtopic = (value, inputIdentifier) => {
        var maxLength = 150;
        var remainingCount = maxLength - value.length;
        return (remainingCount);
    }

    onSubtopicInputChanged = (event, index) => {
        let updatedSubtopicsList = [...this.state.subTopicsList];
        let updatedValue = event.target.value;

        let inputValid = updatedSubtopicsList[index].errorMessage === '';
        let errorMessage = '';

        if (updatedValue.length === 0 || updatedValue.trim() === '') {
            errorMessage = "This is a required field"
            inputValid = inputValid && false;
        } else {
            errorMessage = '';
            inputValid = inputValid && true;
        }

        const updatedRemainingChar = this.checkRemainingCountForSubtopic(updatedValue);
        if (updatedRemainingChar > 0) {
            updatedSubtopicsList[index].value = updatedValue;
        } else {
            updatedSubtopicsList[index].value = updatedValue.substring(0, 150);
        }

        updatedSubtopicsList[index].remainingChar = updatedRemainingChar;
        updatedSubtopicsList[index].errorMessage = errorMessage;
        updatedSubtopicsList[index].valid = inputValid;

        this.setState({ subTopicsList: updatedSubtopicsList });
    }

    onAddNewObjectiveClicked = () => {
        let updatedSubtopicsList = [...this.state.subTopicsList];

        updatedSubtopicsList.forEach(item => {
            if (item.value && item.value.indexOf('||') > -1) {
                const newListItems = item.value.split('||');
                // console.log("New to be split into new entries =>>> ", item.value.split('||'));
                newListItems.forEach(newItem => {
                    updatedSubtopicsList.push({ id: '', value: newItem, errorMessage: '', remainingChar: 150, totalChar: 150, valid: true });
                })
            }
        })

        updatedSubtopicsList.push({ id: '', value: '', errorMessage: '', remainingChar: 150, totalChar: 150, valid: true });

        this.setState({ subTopicsList: updatedSubtopicsList });
    }

    removeSubtopicClicked = (pos) => {
        let updatedSubtopicsList = [...this.state.subTopicsList];
        if (!IsStringEmpty(pos) && pos > -1) {
            if (!IsStringEmpty(updatedSubtopicsList[pos].id)) {
                this.props.onDeleteSubtopicClicked(updatedSubtopicsList[pos].id);
                updatedSubtopicsList.splice(pos, 1);
            } else {
                updatedSubtopicsList.splice(pos, 1);
            }
        }
        this.setState({ subTopicsList: updatedSubtopicsList });
    }

    onFormButtonClicked = () => {
        const updatedForm = this.state.sessionPlanFormData;
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        let updatedSubtopicsList = [...this.state.subTopicsList], subtopicIsValid = true;
        for (var i = 0; i < updatedSubtopicsList.length; i++) {

            let subTopic = updatedSubtopicsList[i];

            subtopicIsValid = subtopicIsValid && subTopic.valid && subTopic.value !== '';
            if (subtopicIsValid === false) {
                if (subTopic.value === '') {
                    updatedSubtopicsList[i].errorMessage = "This is a required field";
                    updatedSubtopicsList[i].valid = false;
                }
            }
        }

        // console.log('STatus before submit -> ', formIsValid, subtopicIsValid)
        this.setState({ sessionPlanFormData: updatedForm, sessionPlanFormValid: formIsValid && subtopicIsValid, subTopicsList: updatedSubtopicsList });

        if (formIsValid && subtopicIsValid) {

            // alert('form is valid')
            let updatedSubtopicsList = [...this.state.subTopicsList], subTopicsList = [];
            for (var i = 0; i < updatedSubtopicsList.length; i++) {
                if (!IsStringEmpty(updatedSubtopicsList[i].id)) {
                    subTopicsList.push({
                        "name": updatedSubtopicsList[i].value,
                        "id": updatedSubtopicsList[i].id
                    });
                } else {
                    subTopicsList.push({
                        "name": updatedSubtopicsList[i].value
                    });
                }
            }

            const newSessionPlanData = {};
            newSessionPlanData["description"] = this.state.sessionPlanFormData.sessionDescription.value;
            newSessionPlanData["sub_topics"] = subTopicsList;

            // console.log("Final Object => ", newSessionPlanData);

            this.props.updateSessionPlanClicked(newSessionPlanData);

        }
    }

    setFormData = () => {
        const sessionPlanData = !IsObjectEmpty(this.props.data) ? this.props.data : {};
        if (!IsObjectEmpty(sessionPlanData)) {
            // alert('Setting UP Initial Data');

            let sessionDescription = '', subTopicsList = [];

            sessionDescription = !IsStringEmpty(sessionPlanData.description) ? sessionPlanData.description : '';

            subTopicsList = !IsListEmpty(sessionPlanData.sessionTopics) ? sessionPlanData.sessionTopics.map((item) => {
                return ({
                    id: item.id,
                    value: item.name,
                    errorMessage: '',
                    remainingChar: (150 - item.name.length),
                    totalChar: 150,
                    valid: true
                });
            }) : [{ id: '', value: '', errorMessage: '', remainingChar: 150, totalChar: 150, valid: true }];

            let updatedFormData = { ...this.state.sessionPlanFormData };
            updatedFormData['sessionDescription'].value = sessionDescription;

            this.setState({ sessionPlanFormData: updatedFormData, subTopicsList: subTopicsList });
        } else {
            // alert('Adding a new Problem');
        }
    }

    componentDidMount() {
        this.setFormData();
    }

    inputField = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.sessionPlanFormData[key].elementType}
            elementConfig={this.state.sessionPlanFormData[key].elementConfig}
            label={this.state.sessionPlanFormData[key].label}
            value={this.state.sessionPlanFormData[key].value}
            disabled={this.state.sessionPlanFormData[key].disabled}
            options={this.state.sessionPlanFormData[key].options}
            changed={key === 'sessionDescription' ? (value) => this.inputChangedHandlerMarkdown(value, key) : (event) => this.inputChangedHandler(event, key)}
            touched={this.state.sessionPlanFormData[key].touched}
            afterText={this.state.sessionPlanFormData[key].remainingChar}
            dropdownOpen={this.state.sessionPlanFormData[key].dropdownOpen}
            onDropDownClick={() => this.onDropDownClick(key)}
            onDropDownItemClick={this.onDropDownItemClick}
            videoType={this.props.videoType}
            required={!IsObjectEmpty(this.state.sessionPlanFormData[key].validation) ? (!IsObjectEmpty(this.state.sessionPlanFormData[key].validation.required) ? this.state.sessionPlanFormData[key].validation.required.value : false) : false}
            showError={(!this.state.sessionPlanFormValid && !this.state.sessionPlanFormData[key].valid) ? true : false}
            error={this.state.sessionPlanFormData[key].errorMessage}
            showImageOption={true}
            fullScreen={true} />
    }

    render() {

        const renderSubTopicsList = !IsListEmpty(this.state.subTopicsList)
            ? this.state.subTopicsList.map((item, index) => {
                return (
                    <div key={index} className={classes.SubtopicItem}>
                        <SubTopicInput
                            pos={index}
                            data={item}
                            disabled={this.props.liveSessionEnded}
                            onInputChanged={this.onSubtopicInputChanged}
                            errorMessage={item.errorMessage}
                            removeSubtopicClicked={this.removeSubtopicClicked}
                        />
                    </div>
                );
            }) : null;

        return (
            <FlexModal visible={true} width={'100%'} maxHeight={"100vh"} forSessionPlanForm={true} fullScreenMobile={true} backdropClicked={() => this.props.closePopup('')}>
                <div className={classes.Form}>

                    <h4 className={classes.Heading}>Update Session Plan</h4>

                    <img src={CloseIcon} alt={'Hide add new problem form'} className={classes.CloseIcon}
                        onClick={this.props.closePopup} />

                    <p className={classes.SubHeading}>Sub-Topics</p>
                    <div className={classes.SubTopicsContainer}>
                        {renderSubTopicsList}
                        {
                            this.state.showError
                                ? <p className={classes.ErrorMessage}>{this.state.errorMessage}</p>
                                : null
                        }
                    </div>
                    {this.props.liveSessionEnded === false
                        ? <div className={classes.AddNewOptionDiv} onClick={this.onAddNewObjectiveClicked}>
                            <img src={AddIcon} alt="Add New Objective" />
                            <p>Add new objective</p>
                        </div>
                        : null}

                    <p className={classes.SubHeading}>Session Description</p>

                    <div className={classes.DescriptionInput}>
                        {this.inputField('sessionDescription')}
                    </div>

                    <div className={classes.SubmitButton}>
                        <Button
                            styleclass="NonMobileOnly"
                            label={"UPDATE SESSION PLAN"}
                            fontSize="0.8em"
                            padding="1em 3.5em"
                            clicked={this.onFormButtonClicked}
                        />
                        <Button
                            width="6em"
                            styleclass="MobileOnly"
                            label={"UPDATE SESSION PLAN"}
                            fontSize="0.625em"
                            padding="1em 3em"
                            margin="0px"
                            clicked={this.onFormButtonClicked}
                        />
                    </div>
                </div>
            </FlexModal>
        );
    }
}

export default SessionPlanForm;